import { disabledStyles } from '../constants/colorStyles'
import { BadgeMode, ColorStyles } from '../types/colorStyles'

export const getDisabledStyles = (mode: BadgeMode, onColor: boolean): ColorStyles =>
  disabledStyles[mode][onColor ? 'onColor' : 'default']
